import { BaseStorage } from "@/storage/BaseStorage";
import { EcleticaTableConfiguration } from "./EcleticaTableConfiguration";
import { EcleticaAPI } from "@/api/EcleticaAPI";

const ecleticaCatalogKey = "of-ecletica-catalog";

export const EcleticaProductTypes = {
  PIZZA: "PIZZA",
  COMBINATION: "COMBINATION",
  COMMON: "COMMON",
};

export class EcleticaCatalog {
  static async install() {
    this.ecleticaConfiguration = EcleticaTableConfiguration.fromStorage();

    this.client = new EcleticaAPI({
      baseUrl: this.ecleticaConfiguration.apiUrl,
      apiToken: this.ecleticaConfiguration.apiToken,
      store: this.ecleticaConfiguration.store,
      network: this.ecleticaConfiguration.network,
      externalId: this.ecleticaConfiguration.externalId,
    });

    const rawProductsResponse = await this.client.getProducts();
    if (rawProductsResponse.getErrors().length > 0) {
      throw new Error(rawProductsResponse.getErrors()[0]);
    }

    const rawProducts = rawProductsResponse.getData();
    const productsMap = new Map(rawProducts.map((product) => [product.cod_item, product]));
    const baseStorage = new BaseStorage({ key: ecleticaCatalogKey });
    baseStorage.setData({
      products: Object.fromEntries(productsMap)
    });
  }

  static getCatalog() {
    try {
      const baseStorage = new BaseStorage({ key: ecleticaCatalogKey });
      const catalog = baseStorage.getData();
      return catalog || {};
    } catch (err) {
      return {};
    }
  }

  static get products() {
    const catalog = EcleticaCatalog.getCatalog();
    return catalog?.products || {};
  }

  static getProductBySku(codItem) {
    const product = EcleticaCatalog.products[codItem];
    return product || null;
  }

  static getProductType(codItem) {
    const product = EcleticaCatalog.products[codItem];

    let type = EcleticaProductTypes.COMMON;

    if (product?.combo === "S") {
      type = EcleticaProductTypes.COMBINATION;
    }

    if (product?.produto_pizza === "S") {
      type = EcleticaProductTypes.PIZZA;
    }

    return type;
  }
}
